import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;

    .input-container {
        width: 100%;
    }

    .file-input {
        display: none;
    }

    .upload-icon {
        margin-right: 8px;
    }

    .delete-icon {
        width: 20px;
    }

    .MuiInputBase-root {
        border: 1px dashed ${(props) => props.theme.palette.primaryA1};

        &.Mui-focused {
            border: 1px dashed ${(props) => props.theme.palette.primaryA1};
        }
    }

    .Mui-error {
        .MuiInputBase-input {
            -webkit-text-fill-color: ${(props) => props.theme.palette.secondaryA4};
        }
    }

    .drag-over {
        .MuiInputBase-root {
            border: 1px solid ${(props) => props.theme.palette.primaryA1};
            background-color: ${(props) => props.theme.palette.primaryA5};
        }

        &.Mui-focused {
            border: 1px solid ${(props) => props.theme.palette.primaryA1};
        }
    }
`;
